import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { GridSIP } from './GridSIP';
import { GridVCS } from './GridVCS';

interface Props extends ParticipantPresenterProps {}

export const Grid = (props: Props) => {
    const { checkIsSIPParticipant } = useSIPParticipant();

    const { participant } = props;
    const isSIPParticipant = checkIsSIPParticipant(participant);

    if (isSIPParticipant) {
        return <GridSIP {...props} />;
    }

    return <GridVCS {...props} />;
};
